const apiAddress = 'https://eecmy-api.madtechet.com';

const constants = {
  apiUrl: `${apiAddress}/api`,
  mediaUrl: `${apiAddress}/media`,
  authUrl: 'auth-xaea12',
  keys: {
    user: 'user',
  },
  prefixes: {
    sorting: 'sorting',
    visibility: 'visibility',
    density: 'density',
    rowsPerPage: 'rows_per_page',
  },
};

export default constants;
